import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="info-mail-modal"
export default class extends Controller {
  connect() {
    if(this.element.dataset.infoMailStatus == 'scheduled') {
      $('#info-mail-modal-title').html('Info Mail editieren')
    } else {
      $('#info-mail-modal-title').html('Info Mail Details')
    }

    $('#info-mail-modal').modal('show');
  }

  disconnect() {
    $('#info-mail-modal').modal('hide');
  }
}
